import { euro } from "./preisAnalyse.js";

/**
 * Stadtseiten-Fragen. Die Formulierungen stammen aus der Search Console —
 * "fotobox mieten berlin preise", "fotobox berlin standorte",
 * "fotoautomat mieten berlin".
 */
export function stadtFaq(stadt, daten) {
  if (!daten) return [];

  const anzahl = daten.lokale.length + daten.anzahlVersand;

  return [
    {
      question: `Was kostet eine Fotobox in ${stadt}?`,
      answer: `Über alle ${daten.anzahlPakete} für ${stadt} verfügbaren Pakete liegt die Hälfte unter ${euro(daten.medianGesamt)} €. Versandboxen beginnen bei ${euro(daten.abPreisVersand)} €, Anbieter aus ${stadt} bei ${euro(daten.abPreisLokal)} € — dort sind es eher hochwertige Boxen wie Spiegel- oder Designmodelle.`,
    },
    {
      question: `Wie viele Anbieter gibt es in ${stadt}?`,
      answer: `${daten.lokale.length} Anbieter aus ${stadt} und Umgebung liefern und bauen auf, dazu kommen ${daten.anzahlVersand} Versandboxen, die per Paket ankommen — zusammen ${anzahl} Fotoboxen.`,
    },
    {
      question: `Gibt es feste Abholstationen in ${stadt}?`,
      answer:
        daten.abholung.length > 0
          ? `Feste Stationen wie bei einem Autoverleih gibt es nicht — die Anbieter arbeiten von ihrem Lager aus. Selbst abholen könnt ihr in ${stadt} bei ${daten.abholung.join(", ")}. Alle anderen liefern zur Location, und Versandboxen kommen per Paket an eure Adresse.`
          : `Feste Stationen gibt es nicht — die Anbieter liefern zur Location, Versandboxen kommen per Paket an eure Adresse.`,
    },
    {
      question: `Kostet die Anfahrt in ${stadt} extra?`,
      answer:
        daten.ohneAnfahrt === daten.lokale.length && daten.lokale.length > 0
          ? `Nein. Bei allen ${daten.lokale.length} Anbietern liegt ${stadt} innerhalb des Liefergebiets, das im Preis enthalten ist. Für Adressen außerhalb rechnen wir die Anfahrt anhand deiner Postleitzahl aus, bevor du anfragst.`
          : `Das hängt vom Anbieter und der Entfernung ab. Im Vergleich rechnen wir die Anfahrt für deine Postleitzahl aus, bevor du anfragst.`,
    },
    {
      question: `Was ist der Unterschied zwischen Fotobox, Fotoautomat und Photobooth?`,
      answer:
        "Keiner — die Begriffe meinen dasselbe Gerät. Photobooth ist das englische Original, Fotoautomat erinnert an die Passbildkabine. Unterschiede gibt es bei der Bauform: klassische Box auf einem Stativ, Spiegel-Fotobox, geschlossene Kabine oder Fotobus.",
    },
    {
      question: `Wie schnell ist eine Fotobox in ${stadt} verfügbar?`,
      answer: `Versandboxen sollten ein bis fünf Tage vor dem Termin ankommen; im Vergleich siehst du zu jedem Datum, ob der Versand noch reicht. Anbieter aus ${stadt} liefern am Tag der Feier oder am Vortag — dort entscheidet die Verfügbarkeit, nicht der Postweg.`,
    },
  ];
}
